import { EASE } from '@/lib/animate';

import type { Transition, Variants } from 'motion/react';

export const SECTION_TRANSITION: Transition = {
  duration: 0.2,
  ease: EASE.outQuint,
};
export const SWAP_TRANSITION: Transition = {
  duration: 0.16,
  ease: EASE.outQuint,
};

export const collapseVariants: Variants = {
  initial: { height: 0, opacity: 0 },
  animate: { height: 'auto', opacity: 1 },
  exit: { height: 0, opacity: 0 },
};

export const blurSwapVariants: Variants = {
  initial: { opacity: 0, filter: 'blur(4px)', y: 4 },
  animate: { opacity: 1, filter: 'blur(0px)', y: 0 },
  exit: { opacity: 0, filter: 'blur(4px)', y: -4 },
};

export const stateSwapVariants: Variants = {
  initial: { opacity: 0, y: 4 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
};
